import type { AuthSession } from "./auth-session";
import { apiClient } from "./client";
import { toApiError } from "./errors";

export interface AdminLoginRequest {
  username: string;
  password: string;
}

export interface AdminTokenResponse {
  access_token: string;
  token_type?: "bearer";
  expires_in: number;
}

export function toAuthSession(payload: AdminTokenResponse): AuthSession {
  return {
    accessToken: payload.access_token,
    tokenType: "bearer",
    expiresAt: Date.now() + Math.max(0, payload.expires_in) * 1000,
  };
}

export async function loginAdmin(
  payload: AdminLoginRequest,
): Promise<AdminTokenResponse> {
  try {
    return await apiClient
      .post("auth/admin/token", { json: payload })
      .json<AdminTokenResponse>();
  } catch (error) {
    throw await toApiError(error);
  }
}
